/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "id";

/** This is an externally generated unique ID associated with a users wordpress account */
export interface UserId {
  wordpressId: number;
}

export interface TripId {
  hexString: string;
}

export interface RouteId {
  hexString: string;
}

export interface RiskSurfaceId {
  hexString: string;
}

export interface WeatherId {
  hexString: string;
}

export interface AlertId {
  hexString: string;
}

export interface TripAndRequestResultIdPair {
  tripId: TripId | undefined;
  isMultistart: boolean;
}

/** The Unique Identifier used for each configuration that defines risk settings */
export interface WeatherRiskConfigId {
  hexString: string;
}

function createBaseUserId(): UserId {
  return { wordpressId: 0 };
}

export const UserId = {
  encode(message: UserId, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.wordpressId !== 0) {
      writer.uint32(8).int64(message.wordpressId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserId {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.wordpressId = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserId {
    return { wordpressId: isSet(object.wordpressId) ? globalThis.Number(object.wordpressId) : 0 };
  },

  toJSON(message: UserId): unknown {
    const obj: any = {};
    if (message.wordpressId !== 0) {
      obj.wordpressId = Math.round(message.wordpressId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserId>, I>>(base?: I): UserId {
    return UserId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserId>, I>>(object: I): UserId {
    const message = createBaseUserId();
    message.wordpressId = object.wordpressId ?? 0;
    return message;
  },
};

function createBaseTripId(): TripId {
  return { hexString: "" };
}

export const TripId = {
  encode(message: TripId, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hexString !== "") {
      writer.uint32(10).string(message.hexString);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TripId {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTripId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.hexString = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TripId {
    return { hexString: isSet(object.hexString) ? globalThis.String(object.hexString) : "" };
  },

  toJSON(message: TripId): unknown {
    const obj: any = {};
    if (message.hexString !== "") {
      obj.hexString = message.hexString;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TripId>, I>>(base?: I): TripId {
    return TripId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TripId>, I>>(object: I): TripId {
    const message = createBaseTripId();
    message.hexString = object.hexString ?? "";
    return message;
  },
};

function createBaseRouteId(): RouteId {
  return { hexString: "" };
}

export const RouteId = {
  encode(message: RouteId, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hexString !== "") {
      writer.uint32(10).string(message.hexString);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RouteId {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRouteId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.hexString = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RouteId {
    return { hexString: isSet(object.hexString) ? globalThis.String(object.hexString) : "" };
  },

  toJSON(message: RouteId): unknown {
    const obj: any = {};
    if (message.hexString !== "") {
      obj.hexString = message.hexString;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RouteId>, I>>(base?: I): RouteId {
    return RouteId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RouteId>, I>>(object: I): RouteId {
    const message = createBaseRouteId();
    message.hexString = object.hexString ?? "";
    return message;
  },
};

function createBaseRiskSurfaceId(): RiskSurfaceId {
  return { hexString: "" };
}

export const RiskSurfaceId = {
  encode(message: RiskSurfaceId, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hexString !== "") {
      writer.uint32(10).string(message.hexString);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RiskSurfaceId {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRiskSurfaceId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.hexString = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RiskSurfaceId {
    return { hexString: isSet(object.hexString) ? globalThis.String(object.hexString) : "" };
  },

  toJSON(message: RiskSurfaceId): unknown {
    const obj: any = {};
    if (message.hexString !== "") {
      obj.hexString = message.hexString;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RiskSurfaceId>, I>>(base?: I): RiskSurfaceId {
    return RiskSurfaceId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RiskSurfaceId>, I>>(object: I): RiskSurfaceId {
    const message = createBaseRiskSurfaceId();
    message.hexString = object.hexString ?? "";
    return message;
  },
};

function createBaseWeatherId(): WeatherId {
  return { hexString: "" };
}

export const WeatherId = {
  encode(message: WeatherId, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hexString !== "") {
      writer.uint32(10).string(message.hexString);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WeatherId {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeatherId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.hexString = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WeatherId {
    return { hexString: isSet(object.hexString) ? globalThis.String(object.hexString) : "" };
  },

  toJSON(message: WeatherId): unknown {
    const obj: any = {};
    if (message.hexString !== "") {
      obj.hexString = message.hexString;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WeatherId>, I>>(base?: I): WeatherId {
    return WeatherId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeatherId>, I>>(object: I): WeatherId {
    const message = createBaseWeatherId();
    message.hexString = object.hexString ?? "";
    return message;
  },
};

function createBaseAlertId(): AlertId {
  return { hexString: "" };
}

export const AlertId = {
  encode(message: AlertId, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hexString !== "") {
      writer.uint32(10).string(message.hexString);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AlertId {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlertId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.hexString = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AlertId {
    return { hexString: isSet(object.hexString) ? globalThis.String(object.hexString) : "" };
  },

  toJSON(message: AlertId): unknown {
    const obj: any = {};
    if (message.hexString !== "") {
      obj.hexString = message.hexString;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AlertId>, I>>(base?: I): AlertId {
    return AlertId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AlertId>, I>>(object: I): AlertId {
    const message = createBaseAlertId();
    message.hexString = object.hexString ?? "";
    return message;
  },
};

function createBaseTripAndRequestResultIdPair(): TripAndRequestResultIdPair {
  return { tripId: undefined, isMultistart: false };
}

export const TripAndRequestResultIdPair = {
  encode(message: TripAndRequestResultIdPair, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tripId !== undefined) {
      TripId.encode(message.tripId, writer.uint32(10).fork()).ldelim();
    }
    if (message.isMultistart !== false) {
      writer.uint32(24).bool(message.isMultistart);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TripAndRequestResultIdPair {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTripAndRequestResultIdPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tripId = TripId.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.isMultistart = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TripAndRequestResultIdPair {
    return {
      tripId: isSet(object.tripId) ? TripId.fromJSON(object.tripId) : undefined,
      isMultistart: isSet(object.isMultistart) ? globalThis.Boolean(object.isMultistart) : false,
    };
  },

  toJSON(message: TripAndRequestResultIdPair): unknown {
    const obj: any = {};
    if (message.tripId !== undefined) {
      obj.tripId = TripId.toJSON(message.tripId);
    }
    if (message.isMultistart !== false) {
      obj.isMultistart = message.isMultistart;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TripAndRequestResultIdPair>, I>>(base?: I): TripAndRequestResultIdPair {
    return TripAndRequestResultIdPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TripAndRequestResultIdPair>, I>>(object: I): TripAndRequestResultIdPair {
    const message = createBaseTripAndRequestResultIdPair();
    message.tripId = (object.tripId !== undefined && object.tripId !== null)
      ? TripId.fromPartial(object.tripId)
      : undefined;
    message.isMultistart = object.isMultistart ?? false;
    return message;
  },
};

function createBaseWeatherRiskConfigId(): WeatherRiskConfigId {
  return { hexString: "" };
}

export const WeatherRiskConfigId = {
  encode(message: WeatherRiskConfigId, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.hexString !== "") {
      writer.uint32(10).string(message.hexString);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WeatherRiskConfigId {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeatherRiskConfigId();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.hexString = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WeatherRiskConfigId {
    return { hexString: isSet(object.hexString) ? globalThis.String(object.hexString) : "" };
  },

  toJSON(message: WeatherRiskConfigId): unknown {
    const obj: any = {};
    if (message.hexString !== "") {
      obj.hexString = message.hexString;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WeatherRiskConfigId>, I>>(base?: I): WeatherRiskConfigId {
    return WeatherRiskConfigId.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeatherRiskConfigId>, I>>(object: I): WeatherRiskConfigId {
    const message = createBaseWeatherRiskConfigId();
    message.hexString = object.hexString ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
